<template>
  <div>
    <Menu/>
    <main id="page-wrap" v-loading="!init">
      <div style="margin-bottom: 54px">
        <Header/>
      </div>
      <router-view v-if="(init && projectId) || $route.name === 'admin' "></router-view>
      <FirstView v-else-if="!projectId"/>
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Menu from '@/components/Menu';
import FirstView from '@/views/Dashboard/components/FirstView';
import InfoView from '@/views/Dashboard/Info/Index';
import firebase from 'firebase';
import dayjs from 'dayjs';
import {addHistory} from '../../firestore/history';

export default {
  name: 'Index',
  components: {FirstView, Menu, Header, InfoView},
  data() {
    return {
      init: false,
      projectId: null,
    };
  },

  created() {
    this.projectId = this.$route.query.project || localStorage.getItem('projectId');
    localStorage.removeItem('filters_' + this.projectId);

    if (this.projectId) {
      firebase.firestore().collection('projects').where('__name__', '==', this.projectId).limit(1)
        .get().then((r) => {
        if (r.empty) {
          this.projectId = null;
        } else {
          r.forEach((subDoc) => {
            const uid = firebase.auth().currentUser.uid;

            if (!subDoc.data().rules[uid]) {
              window.location = '/';
              this.projectId = null;
              localStorage.removeItem('projectId');
            } else {
              const project = subDoc.data();

              addHistory(this.projectId);

              if (project.end_date && project.end_date < dayjs().utc().unix()) {
                window.location = '/';
                this.projectId = null;
                localStorage.removeItem('projectId');
                return;
              }


              this.$store.dispatch('setProject', {
                id: subDoc.id,
                ...project,
              });
            }
          });
        }
      }).catch(() => {
        this.projectId = null;
      }).finally(() => {
        this.init = true;
      });
    } else {
      this.init = true;
    }
  },
};
</script>

<style>
#page-wrap {
  padding-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Index.vue